export default "__VITE_ASSET__DQY4DWke__"